import { render, staticRenderFns } from "./PremiumInvoiceForm.vue?vue&type=template&id=34b383c3&scoped=true"
import script from "./PremiumInvoiceForm.vue?vue&type=script&lang=js"
export * from "./PremiumInvoiceForm.vue?vue&type=script&lang=js"
import style0 from "./PremiumInvoiceForm.vue?vue&type=style&index=0&id=34b383c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b383c3",
  null
  
)

export default component.exports